import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouterProps } from "../../utils/router";

import { get as getResponse } from "../../actions/surveys";
import { pending } from "../../actions/general";
import { tokenize } from "../../actions/auth";
import Template from "../../layout/template";
import Layout from "../../layout";

export class SurveyComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {

        };
        console.log('Survey constructor called!');
    }

    componentDidMount = async () => {
        await this.props.pending(true);

        const params = new URLSearchParams(window.location.search);
        const token = params.get("t");
        const instance = params.get("i");

        if (!!token) {
            await this.props.tokenize(instance, token);
            window.location.href = window.location.origin + window.location.pathname;
        }
        this.fetchData();
    }

    get title() {
        return this.props.page?.title?.trim().length ? this.props.page?.title : this.state.page.title;
    }

    get id() {
        return this.props?.params?.id;
    }

    fetchData = async () => {
        await this.props.pending(true);
        try {
            const response = await this.props.getResponse(this.id);
            // An expired session starts a login redirect and returns no survey.
            // Do not dereference Template or leave the loading overlay active.
            if (!response?.Template) {
                this.setState({ loadError: "This response is unavailable. Please sign in with the recipient account or contact the sender." });
                return;
            }
            const { key, ...definition } = response.Template;
            this.setState({ ...response, json_name: key, Template: definition, loadError: "" });
        } catch {
            this.setState({ loadError: "Unable to load this response. Please try again or contact the sender." });
        } finally {
            await this.props.pending(false);
        }
    }

    onPrivacyChanged = async () => {
        this.setState({ private: true, meta: null, Template: null });
        // Reread via the existing private-response/session/tenant login flow.
        await this.fetchData();
    }


    render() {
        return (
            <>
                <Layout>
                    {this.state.loadError ? <Alert variant="danger">{this.state.loadError}</Alert> : <Template {...this.state?.Template} richTextLabels private={ this.state?.private } data={ this.state.meta?.save?.data } key={this.state?.Template?.key} autosave={ this.state.autosave } logo={this.state?.logos?.normal} invite={ this.id } onPrivacyChanged={this.onPrivacyChanged} />}
                </Layout>
            </>
        )
    }
}

SurveyComponent.propTypes = {
    general: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        general: state.general,
    });
};



export default connect(mapStateToProps, { pending, tokenize, getResponse })(withRouterProps(SurveyComponent));
